// StlLayout.tsx
import React from 'react';

const StlLayout = () => {
  return (
    <div
      className="w-full h-full bg-[#0d0a14]"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg
        width="64"
        height="64"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#475569"
        strokeWidth="1.5"
        style={{ marginBottom: '1rem' }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 7.5l-2.25-1.313M21 7.5v2.25m0-2.25l-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3l2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75l2.25-1.313M12 21.75V19.5m0 2.25l-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"
        />
      </svg>
      <p
        style={{
          color: '#94a3b8',
          fontSize: '1.1rem',
          fontWeight: '600',
          letterSpacing: '0.025em',
          margin: 0,
        }}
      >
        3D Models Coming Soon
      </p>
    </div>
  );
};

export default StlLayout;
